<template>
  <div>
    <div class="flex flex-h-end mb-20">
      <router-link
        to="/admin/organization/reports/generate"
        class="btn btn-gray no-border btn-full-radius inline-flex mr-5"
        >Clear</router-link
      >
    </div>
    <div class="reports-wrapper">
      <div class="grid-full"><h3 class="bold">User Report</h3></div>
      <div class="filters no-check mt-50 relative">
        <div>
          <h3 class="bold">Filter</h3>
          <div class="block mt-10" v-for="aFilter in filters" :key="aFilter">
            <p>{{ aFilter }}</p>
          </div>
        </div>
        <div>
          <h3 class="bold mt-50">Other Filter</h3>
          <p class="mt-5">{{ otherFilters }}</p>
        </div>
      </div>
      <div>
        <div class="btn-wrapper mb-10 move-right">
          <!-- <button
            class="btn-back mr-5"
          >
            <img src="/img/email.svg" alt class="mr-5" /> <span>Email</span>
          </button>
          <button
            class="btn-back mr-5"
          >
            <img src="/img/print.svg" alt class="mr-5" /> <span>Print</span>
          </button> -->
          <div class="inline-flex flex-v-end mr-5">
            <el-select
              v-model="selectedFormat"
              placeholder="Export As"
              class="year-select"
              @change="downloadReport"
              clearable
            >
              <el-option
                v-for="item in downloadFormats"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="table" v-loading="tableLoading">
          <el-table
            :data="employeeReports"
            @selection-change="handleSelectionChange"
            style="width: 100%"
            empty-text="No report available for the selected filters."
          >
            <el-table-column
              v-if="columns.includes('pin')"
              prop="pin"
              label="Pin"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('name')"
              prop="name"
              label="Name"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('email')"
              prop="email"
              label="Email"
              :formatter="tableFormatter"
              width="250"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('gender')"
              prop="gender"
              label="Gender"
              :formatter="tableFormatter"
              width="250"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('employee_type')"
              prop="employee_type"
              label="Employee Type"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('employee_grade')"
              prop="employee_grade"
              label="Employee Grade"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('employee_grade')"
              prop="employee_grade"
              label="Employee Grade"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('department')"
              prop="department"
              label="Department"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('branch')"
              prop="branch"
              label="Branch"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('date_of_birth')"
              prop="date_of_birth"
              label="Date of Birth"
              :formatter="tableFormatter"
              width="220"
            >
              <template slot-scope="scope">
                <div v-if="scope">
                  {{ dateFormatter(scope.row["date_of_birth"]) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="columns.includes('address')"
              prop="address"
              label="Address"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('account_number')"
              prop="account_number"
              label="Account Number"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('account_name')"
              prop="account_name"
              label="Account Name"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('bank')"
              prop="bank"
              label="Bank"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('genotype')"
              prop="genotype"
              label="Genotype"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('mobile_number')"
              prop="mobile_number"
              label="Mobile Number"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('local_government')"
              prop="local_government"
              label="Local Government"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('city')"
              prop="city"
              label="City"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('state')"
              prop="state"
              label="State"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('country')"
              prop="country"
              label="Country"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('appointment_date')"
              prop="appointment_date"
              label="Appointment Date"
              :formatter="tableFormatter"
              width="220"
            >
              <template slot-scope="scope">
                <div v-if="scope">
                  {{ dateFormatter(scope.row["appointment_date"]) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="columns.includes('blood_group')"
              prop="blood_group"
              label="Blood Group"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('nationality')"
              prop="nationality"
              label="Nationality"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('religion')"
              prop="religion"
              label="Religion"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('marital_status')"
              prop="marital_status"
              label="Marital Status"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('employee_category')"
              prop="employee_category"
              label="Employee Category"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('employee_designation')"
              prop="employee_designation"
              label="Employee Designation"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('tax_id')"
              prop="tax_id"
              label="Tax Id"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('rsa_pin')"
              prop="rsa_pin"
              label="Rsa Pin"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('pension_fund_administrator')"
              prop="pension_fund_administrator"
              label="Pension Fund Administrator"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
            <el-table-column
              v-if="columns.includes('bank_branch')"
              prop="bank_branch"
              label="Bank Brach"
              :formatter="tableFormatter"
              width="220"
            ></el-table-column>
          </el-table>
        </div>
        <div class="pagination-container" v-if="!tableLoading">
          <el-pagination
            mini
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="perPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  filterValueToLabelMapping,
  otherFiltersValueToLabelMapping,
} from "../helpers.js";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "admin/organization/reports"
);
import {
  dateFormatter,
  tableFormatter,
  valueFormatter,
} from "@/helpers/functions";
export default {
  data() {
    return {
      filters: [],
      tableFilters: [],
      columns: [],
      otherFilters: "All Users",
      showTable: false,
      selectedFormat: "",
      pageSizes: this.$store.state.admin.pageSizes,
      downloadFormats: this.$store.state.admin.downloadFormats,
      reportsFilter: [
        "Name",
        "Employee ID",
        "Phone No",
        "Email",
        "Status",
        "User Type",
        "Branch",
        "Department",
        "Grade",
        "Birthday",
        "Pin",
        "Address",
      ],
    };
  },
  computed: {
    ...mapState([
      "perPage",
      "total",
      "employeeReports",
      "tableHeading",
      "tableLoading",
    ]),
    currentPage: {
      get() {
        return this.$store.state.admin.organization.reports.currentPage;
      },
      set(value) {
        return this.$store.commit(
          "admin/organization/reports/currentPage",
          value
        );
      },
    },
  },
  mounted() {
    let payload = this.$route.params.payload;
    if (!payload || !payload.columns || !payload.columns.length) {
      this.$router.push("/admin/organization/reports/generate");
      this.$notification.error("Please select filters to generate report.");
      return;
    }
    this.columns = payload.columns;
    this.$store.commit("admin/organization/reports/payload", payload);
    this.filters =
      payload.columns && payload.columns.map(x => filterValueToLabelMapping[x]);
    this.otherFilters =
      payload.columns && otherFiltersValueToLabelMapping[payload.fetch_by];
    this.getReport();
  },
  methods: {
    dateFormatter,
    tableFormatter,
    valueFormatter,
    ...mapActions(["handleSizeChange", "handleCurrentChange"]),
    getReport(payload) {
      this.$store
        .dispatch("admin/organization/reports/getReport", payload)
        .then(() => {})
        .catch(error => {
          this.$notification.error(error.message);
        });
    },

    downloadReport() {
      const format = this.selectedFormat;

      if (format === null || format === "") {
        return false;
      }

      this.$store
        .dispatch("admin/organization/reports/downloadReport", format)
        .then(response => {
          this.$download({ fileName: response.data });
        })
        .catch(error => {
          this.$notification.error(error.message);
        });
    },

    tableCellClassName({ row, column }) {
      if (row.status === "Active" && column.property === "status") {
        return "active";
      } else if (row.status === "Inactive" && column.property === "status") {
        return "inactive";
      }
      return "";
    },

    handleSelectionChange(val) {
      this.tableFilters = val;
    },
    removeFilter(filter) {
      this.filters = this.filters.filter(item => item !== filter);
    },
    clear() {
      this.filters = [];
    },
  },
};
</script>
